@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Pended Invoices</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    @if(processCodes && processCodes.length) {
                    <ppl-invoice-filter [filterFields]="fields" (searchEvent)="onSearch($event)"
                        [processCodes]="processCodes" [pageId]="pageId"></ppl-invoice-filter>
                    <p class="pl-2"> <span class="error-message1">*</span> Atleast one out of the following fields
                        should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.</p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Deny</strong> and <strong>Override</strong> actions, please select the
                                applicable invoice lines.</li>
                            <li>The <strong>Deny All</strong> and <strong>Override All</strong> actions will update all
                                invoice lines that match the search criteria.</li>
                            <li>The <strong>Reprocess</strong> action applies to the selected Denied or Ready for
                                Payment invoice lines that have not been sent to NAV.</li>
                        </ul>
                    </div>
                    }
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="invoices" [customDataLoaded]="true" [enableActions]="false"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [badgeColumns]="['Application Status']"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [isOkText]="okText" (confirm)="handleOk()"
    (cancel)="handleCancel()" [showButtons]="true" [showOkButton]="false" [size]="'medium'" [position]="'center'">
    <form nz-form [formGroup]="invoiceActionForm">
        <nz-form-item>
            <nz-form-control>
                <nz-select [nzMode]="'multiple'" formControlName="selectedProcessCode" class="filters"
                    id="selectedProcessCode" nzPlaceHolder="Select Process Code" nzShowSearch style="width: 100%;"
                    [nzStatus]="invoiceActionForm.get('selectedProcessCode')?.invalid && invoiceActionForm.get('selectedProcessCode')?.touched ? 'error' : ''">
                    @for (opt of allowedProcessCodes; track opt.code) {
                    <nz-option [nzLabel]="opt.displayName" [nzValue]="opt.code"></nz-option>
                    }
                </nz-select>
                @if (invoiceActionForm.get('selectedProcessCode')?.invalid && invoiceActionForm.get('selectedProcessCode')?.touched) {
                <div class="error-message">Please select a process code.</div>
                }
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control>
                <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason"
                    nzShowSearch style="width: 100%;"
                    [nzStatus]="invoiceActionForm.get('reason')?.invalid && invoiceActionForm.get('reason')?.touched ? 'error' : ''">
                    @for (opt of reasonList; track opt.lkpValueCode) {
                    <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                    }
                </nz-select>
                @if (invoiceActionForm.get('reason')?.invalid && invoiceActionForm.get('reason')?.touched) {
                <div class="error-message">Please select a reason.</div>
                }
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control>
                <label for="comments" class="field-header">Comments</label>
                <nz-textarea-count [nzMaxCharacterCount]="10000">
                    <textarea rows="3" nz-input id="comments" formControlName="comments" placeholder="Start typing..."
                        [maxlength]="10000"
                        [nzStatus]="invoiceActionForm.get('comments')?.invalid && invoiceActionForm.get('comments')?.touched ? 'error' : ''"></textarea>
                </nz-textarea-count>
                @if (invoiceActionForm.get('comments')?.invalid && invoiceActionForm.get('comments')?.touched) {
                <div class="error-message">Please enter a message.</div>
                }
            </nz-form-control>
        </nz-form-item>
    </form>
</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> This action will apply to all invoice lines that meet the search criteria. Do you want to continue?</p>
    </ng-template>
</div>

<ppl-correction-notes-dialog [(visible)]="showReprocessPopup" title="Reprocess" okText="Reprocess"
    [message]="reprocessIds.length + ' selected invoice line(s) will be reprocessed. Lines already sent to NAV will not be reprocessed.'"
    placeholder="Reason for reprocessing" (confirmed)="submitReprocess($event)">
</ppl-correction-notes-dialog>
